import {useCallback, useEffect, useMemo, useState} from "preact/hooks";
import React from "preact/compat";
import {Gtag} from "@/services/gtag.ts";
import { Url } from "@/helpers/url";

export const useSearchCommon = () => {
    const searchText = useMemo(() => {
        const value = window?.location?.search ?? "";

        return Url.getQueryParam("q", value) ?? "";
    }, [window?.location?.search]);

    const [searchValue, setSearchValue] = useState(searchText);

    useEffect(() => {
        setSearchValue(searchText);
    }, [searchText, setSearchValue]);

    const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchValue(e.currentTarget.value);
    }, [setSearchValue]);

    const navigateToSearchPage = useCallback((search: string) => {
        Gtag.pushEvent("search_input", search);
        Url.route(
            Url.to("search-page", {}, `?q=${encodeURIComponent(search)}`)
        );
    }, []);

    const search = useCallback(() => {
        const normalized = searchValue.trim();
        if (normalized.length) {
            navigateToSearchPage(normalized);
        }
    }, [searchValue, navigateToSearchPage]);

    const handleKeyDown = useCallback((e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter") {
            search();
        }
    }, [search]);

    const handleBlur = useCallback(() => {
        search();
    }, [search]);

    const jsonLdDataset = useMemo(() => ({
        search: true,
    }), []);

    return {
        search,
        searchValue,
        handleChange,
        handleKeyDown,
        handleBlur,
        jsonLdDataset,
    }
}